import { TableHeader } from 'components/common/Table/Table';

export const HEADERS: Array<TableHeader> = [
  { content: 'Name', field: 'name' },
  { content: 'Description', field: 'description' },
  { content: 'Secret', field: 'maskedSecret' },
  { content: 'Create Date', field: 'createDate' },
  { content: 'Author', field: 'author' },
  { content: 'Actions', field: 'actions' },
];

export const isNameValidRegex = /^[a-zA-Z0-9]+$/;
export const isDescriptionValidRegex = /^.*$/;
export const isSecretValidRegex = /^(?!$|\s+$).*/;
